module.exports = __webpack_public_path__ + "static/media/mobile_informativo_01.460e7914.png";